import React from 'react'
import Modal from '../Modal'
import Typography from '../Typography'
import { Button } from '../Button'
import startForFreeVideo from '../../../assets/video/start-for-free.mp4'
import * as s from './modalAd.module.scss'
import { renderTextWithHighlight } from '../../../utils'

interface ModalAdProps {
  onClose: () => void
  onConfirm: () => void
  titleModal: string
  titleText: string
  description: string
  highlightDescriptionWordsByIdx?: number[]
  classNameHighlightText: string
  buttonText: string
  subText: string
}

const ModalAd: React.FC<ModalAdProps> = ({
  onClose,
  onConfirm,
  titleModal,
  titleText,
  description,
  highlightDescriptionWordsByIdx,
  classNameHighlightText,
  buttonText,
  subText,
}) => {
  return (
    <Modal
      onClose={onClose}
      title={titleModal}
      contentClassName={s.modal_content}
    >
      <div className={s.content}>
        <div>
          <Typography variant="body1" color="blue" size={18}>
            {titleText}
          </Typography>
          <Typography variant="body1" size={18}>
            {renderTextWithHighlight(
              description,
              highlightDescriptionWordsByIdx,
              s[classNameHighlightText]
            )}
          </Typography>
        </div>
        <video autoPlay muted loop playsInline title={titleModal}>
          <source src={startForFreeVideo} type="video/mp4" />
        </video>
        <div>
          <Button isFullWidth onClick={onConfirm}>
            {buttonText}
          </Button>
          <Typography variant="body1" color="gray" mt={16}>
            {subText}
          </Typography>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAd
